export const ADD_INGREDIENT = 'ADD_INGREDIENT';
export const DOWNLOAD_DATA = 'DOWNLOAD_DATA';
export const UPDATE_PAYMENT_TRANSACTIONS = 'UPDATE_PAYMENT_TRANSACTIONS';
export const UPDATE_DTDC_TRACKING_NUMBER_COUNT = 'UPDATE_DTDC_TRACKING_NUMBER_COUNT';